import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import ProductDetailTable from './productDetailTable';
import ValueStreamDetailTable from 'components/Agile/valueStream/valueStreamDetail/valueStreamDetailTable';
import ProductEdit from '../productMaintenance/productEdit';
import { getProductDisplayData } from 'services/productService';
import { getValueStreamDisplayData } from 'services/valueStreamService';
import {
    onEditProduct,
    onDeleteProduct,
} from 'actions/product';
import DeleteItemCheck from 'components/deleteItemCheck';
// import { TIGHT_FIT_PARAM } from 'constants/System';

const ProductDetail = () => {
    // const defaultWidth = width > TIGHT_FIT_PARAM ? 150 : 80;
    const dispatch = useDispatch();

    // const allValueStreams = useSelector(state => state.valueStreams.allValueStream);
    const selectedProduct = useSelector(state => state.products.selectedProduct);
    const selectedOrg = useSelector(state => state.orgs.selectedOrg);
    const [valueStreamDisplayData, setValueStreamDisplayData] = useState();
    const [displayData, setDisplayData] = useState();

    useEffect(() => {
        // TODO - do not fetch if no selected product
        let mounted = true; // fix warning on no-op state when component not mounted https://www.debuggr.io/react-update-unmounted-component/
        const productPromise = new Promise((resolve) => resolve(getProductDisplayData(selectedProduct, selectedOrg?.id)));
        const valueStreamPromise = new Promise((resolve) => resolve(getValueStreamDisplayData(selectedProduct?.valueStreamId, selectedOrg?.id)));

        const fetchDisplayData = async () => {
            await Promise.all([productPromise, valueStreamPromise]
                .map((result) => result.catch((error) => error)))
                .then((values) => {
                    const [
                        productDisplayData,
                        valueStreamDisplayData] = values;
                    setDisplayData(productDisplayData);
                    setValueStreamDisplayData(valueStreamDisplayData);
                });
        };
        if (mounted) {
            fetchDisplayData();
        }
        return () => mounted = false;
    }, [selectedProduct]);

    const mainIcon = () => {
        // TODO pass in type to change the icon on the detail tab
        // if (type && type.toLowerCase() === 'high') {
        //     return 'stream';
        // }
        // if (type && type.toLowerCase() === 'medium') {
        //     return 'compact';
        // }
        // if (type && type.toLowerCase() === 'low') {
        //     return 'module';
        // }
        return 'dashboard';
    };

    if (selectedProduct) {
        // const fields = { ...selectedProduct?.fields };
        return (
            <div className="dashboard animated slideInUpTiny animation-duration-3">
                <div className="row">
                    <div className="col-md-7 col-12">
                        <div className="jr-card jr-card-full-height ml-2 mr-2">
                            <div className="jr-card-header d-flex">
                                <div className="mr-auto">
                                    <h2 className="card-heading">{displayData?.name}</h2>
                                </div>
                                <div>
                                    <DeleteItemCheck
                                        id={selectedProduct?.id}
                                        onConfirm={onDeleteProduct}
                                        alertMessage={<IntlMessages id="product.deleteProduct" />}
                                    />
                                    <Button size="sm" color="primary" onClick={() => dispatch(onEditProduct(selectedProduct))}>
                                        <i className="zmdi zmdi-edit zmdi-hc-fw" />
                                        <span>{<IntlMessages id="label.edit" />}</span>
                                    </Button>
                                </div>
                            </div>
                            <div className="jr-card-body">
                                <div className="row">
                                    <div className="col-sm-3">
                                        <div className="temp-section mb-4 mb-sm-0 text-center text-sm-left">
                                            <p>
                                                {/* <div className={`btn btn-sm text-uppercase btn-rounded ${style}`}>{order} Order</div> */}
                                                <i className={`detail-icon text-blue-grey zmdi zmdi-view-${mainIcon()} zmdi-hc-fw`} />
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-sm-9 text-center text-sm-left">
                                        <ProductDetailTable displayData={displayData} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ProductEdit />
                    </div>

                    <div className="col-md-5">
                        <div className="jr-card jr-card-full-height ml-2 mr-2">
                            <div className="mr-auto">
                                <h2 className="card-heading">{<IntlMessages id="product.valueStreams" />}</h2>
                            </div>
                            <div>
                                <ValueStreamDetailTable displayData={valueStreamDisplayData} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className="dashboard animated slideInUpTiny animation-duration-3">
                <div className="row">
                    <div className="col-md-12 col-12">
                        <div className="jr-card jr-card-full-height">
                            <div className="jr-card-header d-flex">
                                <div className="mr-auto">
                                    <h3 className="card-heading">Please select an entry to display details</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default ProductDetail;


// WEBPACK FOOTER //
// ./components/Agile/product/productDetail/index.js